import HotelAccordion from './HotelAccordion'

export default HotelAccordion
